import React from 'react'
import Skeleton from '@mui/lab/Skeleton'
import MobileScreen from 'mobile/components/MobileScreen'
// import { MobileAppBar, MobileTab, TabPanel } from 'mobile/utils'

import SearchFields from './components/SearchFields'

const MyOrdersSkeleton = () => {
  return (
  <MobileScreen
    title="My Orders"
    titleIcon="shopping_basket"
    CollapsableSearchComponent={SearchFields}
  >
    <div style={{ width: '100%' }}>
      <Skeleton animation="wave" variant="rect" width="100%" height="250" />
    </div>
  </MobileScreen>
)}

export default MyOrdersSkeleton